export default "__VITE_ASSET__SpSjPwBH__"